module.exports = __webpack_public_path__ + "img/periode_awal.91dcdb68.svg";